const DIFF = 'diff';
const SLIDER = 'slider';
const FADE = 'fade';

export const COMPARE_METHODS = {DIFF, SLIDER, FADE} as const;

export type CompareMethod =
  (typeof COMPARE_METHODS)[keyof typeof COMPARE_METHODS];

export const COMPARE_TYPES = {
  RESULT: 'result',
  MOSAIC: 'mosaic',
  SCENE: 'item',
  VISUAL_ANALYSIS: 'visualAnalysis',
} as const;

export type CompareType = (typeof COMPARE_TYPES)[keyof typeof COMPARE_TYPES];
